import { Button, Fieldset, H2 } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';

import { EMBEDDED_QUOTE_LEADS_CAPTURE_FEATURE } from '../../../../../../ahm-constants/ui';
import { HealthFormValues } from '../../../../types';
import { ModalComponentProps } from '../../../../../../components/embedded-widget/types';
import { useFeatureIsOn } from '../../../../../../../../utils/growth-book/hooks';
import AddYourDetailsFields from '../../../../../refine-price/form/add-your-details-fields';
import AgeField from './age-field';
import getHasPartner from '../../../../utils/get-has-partner';
import styles from './styles.module.sass';

export const labelText = {
  age: 'My age',
  partnerAge: 'My partner’s age',
};

const AgeSelector = ({ setIsModalOpen }: ModalComponentProps) => {
  const { values } = useFormikContext<HealthFormValues>();
  const leadCaptureDisabled = useFeatureIsOn(EMBEDDED_QUOTE_LEADS_CAPTURE_FEATURE);

  const { age, partnerAge, scale }: { age?: number | null; partnerAge?: number | null; scale: string } = values;

  const hasPartner = getHasPartner(scale);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={styles.outerWrapper}>
      <Fieldset>
        <H2 looksLike="h5">{`Please enter your age${hasPartner ? ' and your partner’s age' : ''}`}</H2>
        <AgeField age={age} labelText={labelText.age} name="age" />
        {hasPartner && <AgeField age={partnerAge} labelText={labelText.partnerAge} name="partnerAge" />}
      </Fieldset>

      {!leadCaptureDisabled && (
        <Fieldset>
          <AddYourDetailsFields />
        </Fieldset>
      )}

      <Button variant={['wide', 'white', 'border']} onClick={() => handleClose()}>
        Done
      </Button>
    </div>
  );
};

export default AgeSelector;
